export default function registerPWAEvents() {
    window.addEventListener('beforeinstallprompt', (event) => {
        (<any>window).beforeinstallpromptEvent = event;
    });
    window.addEventListener('appinstalled', (event) => {
        (<any>window).beforeinstallpromptEvent = null;
    });
}
